import React from "react"

const CardHeadline = ({ children }) => (
  <h3 className="title p-t-md">
    {children}
  </h3>
)

export default CardHeadline
